








































































































































































//@ts-nocheck
import TitleBar from "@/components/Elements/TitleBar.vue";

import { Component, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";

import { STORE_KEY, store } from "./_store";
import {
  columnTotals as calcColumnTotals,
  monthLabel
} from "./pivotSemifinishedRequirement";
import { writeSemifinishedRequirementWorkbookBuffer } from "./buildSemifinishedRequirementWorkbook";
import moment from "moment";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",
      "items",
      "months"
    ])
  },
  components: {
    TitleBar
  }
})
export default class SemifinishedRequirementReport extends Vue {
  months!: string[];
  items!: any[];

  get titleStack() {
    return ["Отчеты", "Потребность в полуфабрикате"];
  }

  get columnTotals() {
    return calcColumnTotals(this.items, this.months);
  }

  localFilter = {
    date_from: moment()
      .startOf("month")
      .toDate(),
    date_to: moment()
      .startOf("month")
      .toDate(),
    products: [],
    semifinisheds: [],
    split: false
  };

  monthLabel(month: string) {
    return monthLabel(month);
  }

  tableToExcel() {
    if (!this.items || this.items.length === 0) {
      console.warn(
        "[SemifinishedRequirementReport.tableToExcel] empty items — skip download"
      );
      return;
    }

    writeSemifinishedRequirementWorkbookBuffer(
      this.items,
      this.months,
      this.localFilter.split
    )
      .then((xls64: any) => {
        const a = document.createElement("a");
        const data = new Blob([xls64], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = URL.createObjectURL(data);
        a.href = url;
        a.download = "export.xlsx";
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 0);
      })
      .catch((error: any) => {
        console.error("[SemifinishedRequirementReport.tableToExcel] ERROR", {
          message: error && error.message,
          stack: error && error.stack
        });
      });
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.localFilter.date_from =
      this.$route.query && this.$route.query.date_from
        ? moment(this.$route.query.date_from).toDate()
        : moment()
            .startOf("month")
            .toDate();
    this.localFilter.date_to =
      this.$route.query && this.$route.query.date_to
        ? moment(this.$route.query.date_to).toDate()
        : moment()
            .startOf("month")
            .toDate();
    this.localFilter.products = this.normalizeQueryIds(
      this.$route.query.products
    );
    this.localFilter.semifinisheds = this.normalizeQueryIds(
      this.$route.query.semifinisheds
    );
    this.localFilter.split = this.$route.query.split === "true";

    this.handleParamsChange();
  }

  normalizeQueryIds(value: any) {
    if (!value) {
      return [];
    }
    return Array.isArray(value) ? value : [value];
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key: any) => {
      // @ts-ignore
      switch (key) {
        case "date_from":
        case "date_to":
          ac[key] = moment(this.localFilter[key]).format("YYYY-MM-DD");
          break;
        default:
          ac[key] = this.localFilter[key];
      }
      return ac;
    }, {});

    this.$router.replace({
      query
    });
  }

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }
}
